import { render, staticRenderFns } from "./salesInCarOrderDetail.vue?vue&type=template&id=af6f556a&"
import script from "./salesInCarOrderDetail.vue?vue&type=script&lang=js&"
export * from "./salesInCarOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./salesInCarOrderDetail.vue?vue&type=style&index=0&id=af6f556a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports